import { useState, useContext } from "react"
import {
	Center,
	Box,
	Button,
	FormControl,
	Input,
	Image,
	Stack,
	Text,
} from "@chakra-ui/react"
import { UserContext } from "../Contexts/UserContext"
import { Partners } from "../partnershipData"

export const JobRequestAccessQuestionaire = ({
	nextStep,
	bdpsAccessInfo,
	handleBdpsAccessChange,
}) => {
	const { userPlus } = useContext(UserContext)
	const partner = Partners.find((p) => p.id === userPlus?.partner)
	const [selectedTypes, setSelectedTypes] = useState([]) // Track selected type

	const handleSomeoneHome = () => {
		handleBdpsAccessChange("homeOwnerAvailable", true)
		handleClick("home")
	}

	const handleClick = (type) => {
		// Check if the type is already in the array
		if (selectedTypes.includes(type)) {
			// Remove the type if it exists
			setSelectedTypes(selectedTypes.filter((t) => t !== type))
		} else {
			// Add the type if it doesn't exist
			setSelectedTypes([...selectedTypes, type])
		}
	}

	return (
		<Center
			flexDirection="column"
			maxW="629px"
			margin={{ base: "15px", md: "auto" }}
			gap={3}
		>
			<Stack>
				<Text mb="20px" fontWeight="bold" fontSize="md">
					To save time, let us know how the vendor can access the property.
				</Text>
				<Stack p="10px" w="100%" display="flex" alignItems="center">
					<Box
						as="button"
						onClick={() => handleClick("lockcode")}
						cursor="pointer"
						_hover={{ transform: "scale(1.05)" }}
						transition="transform 0.2s"
						border={selectedTypes.includes("lockcode") ? "2px solid" : "none"}
						borderColor={
							selectedTypes.includes("lockcode") ? "borderColor" : "transparent"
						}
						borderRadius="md"
					>
						<Image
							src={
								partner
									? `/assets/${partner.id}_lock_icon.svg`
									: "/assets/lock_icon.svg"
							}
							alt="Lock Code"
							boxSize="150px"
							mx="auto"
						/>
					</Box>
					<Text mt="10px">Lock Code</Text>
				</Stack>
				{selectedTypes.includes("lockcode") && (
					<>
						<FormControl>
							<Input
								type="text"
								bgColor="white"
								placeholder="Enter Lock Code Combination"
								value={bdpsAccessInfo.lockCode}
								onChange={(e) =>
									handleBdpsAccessChange("lockCode", e.target.value)
								}
							/>
						</FormControl>
						<FormControl>
							<Input
								type="text"
								bgColor="white"
								placeholder="Enter Lock Code Location"
								value={bdpsAccessInfo.lockCodeLocation}
								onChange={(e) =>
									handleBdpsAccessChange("lockCodeLocation", e.target.value)
								}
							/>
						</FormControl>
					</>
				)}
				<Stack p="10px" w="100%" display="flex" alignItems="center">
					<Box
						as="button"
						onClick={() => handleClick("keycode")}
						cursor="pointer"
						_hover={{ transform: "scale(1.05)" }}
						transition="transform 0.2s"
						border={selectedTypes.includes("keycode") ? "2px solid" : "none"}
						borderColor={
							selectedTypes.includes("keycode") ? "borderColor" : "transparent"
						}
						borderRadius="md"
					>
						<Image
							src={
								partner
									? `/assets/${partner.id}_key_code_icon.svg`
									: "/assets/key_code_icon.svg"
							}
							alt="Key Code"
							boxSize="150px"
							mx="auto"
						/>
					</Box>
					<Text mt="10px">Key Code</Text>
				</Stack>
				{selectedTypes.includes("keycode") && (
					<FormControl>
						<Input
							type="text"
							bgColor="white"
							placeholder="Enter Key Code Combination"
							value={bdpsAccessInfo.keyCode}
							onChange={(e) =>
								handleBdpsAccessChange("keyCode", e.target.value)
							}
						/>
					</FormControl>
				)}
				<Stack p="10px" w="100%" display="flex" alignItems="center">
					<Box
						as="button"
						onClick={() => handleClick("gatecode")}
						cursor="pointer"
						_hover={{ transform: "scale(1.05)" }}
						transition="transform 0.2s"
						border={selectedTypes.includes("gatecode") ? "2px solid" : "none"}
						borderColor={
							selectedTypes.includes("gatecode") ? "borderColor" : "transparent"
						}
						borderRadius="md"
					>
						<Image
							src={
								partner
									? `/assets/${partner.id}_gate_icon.svg`
									: "/assets/gate_icon.svg"
							}
							alt="Key Code"
							boxSize="150px"
							mx="auto"
						/>
					</Box>
					<Text mt="10px">Gate Code</Text>
				</Stack>
				{selectedTypes.includes("gatecode") && (
					<FormControl>
						<Input
							type="text"
							bgColor="white"
							placeholder="Enter Gate Code Combination"
							value={bdpsAccessInfo.keyCode}
							onChange={(e) =>
								handleBdpsAccessChange("gateCode", e.target.value)
							}
						/>
					</FormControl>
				)}
				<Stack p="10px" w="100%" display="flex" alignItems="center">
					<Box
						as="button"
						onClick={() => handleSomeoneHome()}
						cursor="pointer"
						_hover={{ transform: "scale(1.05)" }}
						transition="transform 0.2s"
						border={selectedTypes.includes("home") ? "2px solid" : "none"}
						borderColor={
							selectedTypes.includes("home") ? "borderColor" : "transparent"
						}
						borderRadius="md"
					>
						<Image
							src={
								partner
									? `/assets/${partner.id}_door_icon.svg`
									: "/assets/door_icon.svg"
							}
							alt="Key Code"
							boxSize="150px"
							mx="auto"
						/>
					</Box>
					<Text mt="10px">Someone Will Be Home</Text>
				</Stack>
				<Button
					onClick={() => nextStep()}
					bgColor="borderColor"
					color="white"
					w="100%"
					mt="10px"
					mb="40px"
					isDisabled={selectedTypes.length === 0} // Disable button if no type is selected
				>
					Continue
				</Button>
			</Stack>
		</Center>
	)
}
